import {useState, useEffect} from 'react';

/**
 * @param {boolean} openWidget
 * @returns {{hasInteracted: boolean, setHasInteracted: Function}}
 */
export default function useDelayLoad({openWidget}) {
  const [hasInteracted, setHasInteracted] = useState(() =>
    Boolean(window.location.hash || openWidget)
  );

  useEffect(() => {
    const triggerLoad = () => {
      if (hasInteracted) return;

      setHasInteracted(true);

      // Remove listeners after first interaction
      document.removeEventListener('mousemove', triggerLoad);
      document.removeEventListener('scroll', triggerLoad);
      document.removeEventListener('touchstart', triggerLoad);
    };

    document.addEventListener('mousemove', triggerLoad);
    document.addEventListener('scroll', triggerLoad);
    document.addEventListener('touchstart', triggerLoad);

    return () => {
      document.removeEventListener('mousemove', triggerLoad);
      document.removeEventListener('scroll', triggerLoad);
      document.removeEventListener('touchstart', triggerLoad);
    };
  }, [hasInteracted]);

  return {hasInteracted, setHasInteracted};
}
